import { Suspense, lazy } from 'react';
import { useContext } from 'react';
import { ObjectPageContext } from '../../../pages/Context/ObjectPageContext';
import { ForSaleStrings } from '~js/React/types/ForSaleString';
const ProjectObjectsTable = lazy(() => import('./ProjectObjectsTable'));
const ObjectTables = () => {
  const { estate: office } = useContext(ObjectPageContext);
  const tableTitle =
    office?.housingCooperatives && office?.housingCooperatives?.length > 0
      ? ForSaleStrings.Estates
      : (office?.houses && office?.houses.length > 0) ||
        (office?.housingCooperatives && office?.housingCooperatives?.length > 0)
      ? 'Villor'
      : office?.plots && office?.plots.length > 0
      ? 'Tomter'
      : ForSaleStrings.Estates;

  return (
    <>
      {((office?.housingCooperatives &&
        office?.housingCooperatives?.length > 0) ||
        (office?.houses && office?.houses.length > 0) ||
        (office?.housingCooperatives &&
          office?.housingCooperatives?.length > 0) ||
        (office?.cottages && office?.cottages.length > 0) ||
        (office?.plots && office?.plots.length > 0)) && (
        <div className="m-auto px-0 lg:px-4 xxl:px-10">
          <h2 className="font-icb text-2xl lg:text-3xl mb-4 lg:mb-6">
            {tableTitle} i projektet
          </h2>
        </div>
      )}
      <Suspense>
        {office?.housingCooperatives &&
          office?.housingCooperatives?.length > 0 && (
            <ProjectObjectsTable
              projects={office?.housingCooperatives}
              type="housingCooperatives"
            />
          )}
        {office?.houses && office?.houses.length > 0 && (
          <ProjectObjectsTable projects={office?.houses} type="houses" />
        )}
        {office?.plots && office?.plots.length > 0 && (
          <ProjectObjectsTable projects={office?.plots} type="plots" />
        )}
        {office?.cottages && office?.cottages.length > 0 && (
          <ProjectObjectsTable projects={office?.cottages} type="cottages" />
        )}
      </Suspense>
    </>
  );
};

export default ObjectTables;
